import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { useDatasets } from '@monorepo/shared/hooks/workflows/useDatasets';
import { bodyMedium } from '@monorepo/shared/styles/text';
import { formComboboxWidthRem } from '@monorepo/workflowDataSetup/src/components/shared/DatasetPicker/styled';
import { DatasetResponse } from 'mapistry-shared';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { DatasetInfo } from '../../shared/DatasetPicker/DatasetInfo';
import { DatasetPicker } from '../../shared/DatasetPicker/DatasetPicker';
import { EmptyDatasetList } from '../../shared/DatasetPicker/EmptyDatasetList';
import { JoinToPrefixInput } from './JoinToPrefixInput';

interface JoinToDatasetPickerProps {
  isJoinToDatasetLoading: boolean;
  isNewStep?: boolean;
  joinToDatasetLoadingError?: string;
  onAfterChange: (value: string | undefined) => void;
  organizationId: string;
  selectedJoinToDataset?: DatasetResponse;
  stepInputDataset: DatasetResponse;
  workflowOutputDataset: DatasetResponse;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const DatasetPickerContainer = styled.div`
  position: relative;
`;

const StyledJoinToDatasetLoader = styled(Loading)`
  position: absolute;
  top: 0;
  left: ${formComboboxWidthRem + 1}rem;
  width: 20px;
`;

const StyledLabel = styled.div`
  ${bodyMedium}
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
`;

const StyledDatasetInfo = styled(DatasetInfo)`
  margin-bottom: 1.5rem;
`;

const StyledJoinToPrefixInput = styled(JoinToPrefixInput)`
  width: 35rem;
`;

export function JoinToDatasetPicker({
  isJoinToDatasetLoading,
  isNewStep,
  joinToDatasetLoadingError,
  onAfterChange,
  organizationId,
  selectedJoinToDataset,
  stepInputDataset,
  workflowOutputDataset,
}: JoinToDatasetPickerProps) {
  const { datasets, isFetching } = useDatasets({
    organizationId,
  });

  const filteredDatasets = useMemo(() => {
    if (!datasets) {
      return [];
    }

    return datasets.filter(
      (d) => d.id !== stepInputDataset.id && d.id !== workflowOutputDataset.id,
    );
  }, [datasets, stepInputDataset.id, workflowOutputDataset.id]);

  if (isFetching) {
    return <Loading size="medium" />;
  }

  if (!filteredDatasets.length) {
    return <EmptyDatasetList />;
  }

  const showUneditableDatasetDisplay = () => (
    <>
      <StyledLabel>Data source 2</StyledLabel>
      {selectedJoinToDataset ? (
        <StyledDatasetInfo dataset={selectedJoinToDataset} isLocked />
      ) : (
        <Loading />
      )}
    </>
  );

  return (
    <Container>
      {isNewStep ? (
        <DatasetPickerContainer>
          <DatasetPicker
            datasets={filteredDatasets}
            externalError={joinToDatasetLoadingError}
            fieldName="joinToDatasetId"
            label="Data source 2"
            onAfterChange={onAfterChange}
            required
          />
          {isJoinToDatasetLoading && <StyledJoinToDatasetLoader size="small" />}
        </DatasetPickerContainer>
      ) : (
        showUneditableDatasetDisplay()
      )}
      <StyledJoinToPrefixInput datasets={filteredDatasets} />
    </Container>
  );
}
